import type { PropertyPath } from 'lodash-es';

import configurationConsumer from './configurationConsumer';
import { getConfigByKey } from './getConfigByKey';
import type { Configuration } from './types';

/**
 * Loads JSON configuration on the server and reads the given keys by path.
 * Each entry maps an output property name to a configuration path passed to `getConfigByKey`.
 */
export async function loadServerConfig(
    region: string,
    lob: string,
    keys: Record<string, PropertyPath>,
): Promise<Record<string, unknown>> {
    let configuration: Configuration | undefined;
    try {
        ({ configuration } = await configurationConsumer.getInstance({ region, lob }));
    } catch (error) {
        console.warn('Failed to load configuration:', error);
    }

    const read = getConfigByKey(configuration);
    const result: Record<string, unknown> = {};

    for (const [prop, key] of Object.entries(keys)) {
        result[prop] = read(key);
    }

    return result;
}
